/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_3_TitleInputs */

const en_mk_parts_3_title = /** @type {(inputs: Mk_Parts_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents with a role, not a chatbot`)
};

const id_mk_parts_3_title = /** @type {(inputs: Mk_Parts_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen yang punya peran, bukan chatbot`)
};

/**
* | output |
* | --- |
* | "Agents with a role, not a chatbot" |
*
* @param {Mk_Parts_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_3_title = /** @type {((inputs?: Mk_Parts_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_3_title(inputs)
	return en_mk_parts_3_title(inputs)
});